import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.readonly)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args)), ["prevent","stop"])),
        class: "cursor-pointer hover:text-next-orange relative flex items-center"
      }, [
        (_ctx.confirmDelete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
              _createElementVNode("span", null, "Premi nuovamente per confermare.", -1)
            ])))
          : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-cestino h-4" }, null, -1))
            ])
      ]))
    : _createCommentVNode("", true)
}